/**
 * Provider Detail Page
 */

import { Truck } from 'lucide-react'
import { CatalogDetailPage } from './CatalogDetailPage'
import { useTranslation } from '@/hooks/useTranslation'

export function ProviderDetailPage() {
  const { t } = useTranslation()

  return (
    <CatalogDetailPage
      config={{
        endpoint: 'providers',
        basePath: '/providers',
        title: t('catalogs.providers'),
        editLabel: t('catalogs.editProvider'),
        icon: Truck,
        fields: [
          { key: 'name', label: t('catalogs.providerName') },
          {
            key: 'type_identification',
            label: t('clients.identificationType'),
            format: (value) => t(`idTypes.type${value}`),
          },
          { key: 'identification', label: t('clients.identification') },
          { key: 'contact_name', label: t('catalogs.contactName') },
          { key: 'email', label: t('clients.email'), type: 'email' },
          { key: 'phone', label: t('clients.phone'), type: 'phone' },
          { key: 'address', label: t('clients.address'), type: 'address' },
          { key: 'economic_activity', label: t('catalogs.economicActivity') },
        ],
      }}
    />
  )
}
